import { useContext } from "react";
import API from "../../../services/API";
import Picture from "../../Inputs/Picture";
import ToastContext from "../../../services/Context/ToastContext";

export default function CoursePicture({value, onChange}){

    const {setToast} = useContext(ToastContext)

    const handleChange = file => {

        onChange(file)

        if(file){

            API.upload('/pictures', file) 
                .then(r => onChange(r.data))
                .catch(e => {
                    onChange(null)
                    setToast({severity: 'error', message: "Image trop lourde ou format incorrect"})
                })

        }else if(!file){

            API.delete(`/files/${value.name}`)
        }
    }

    return <Picture
        id='course-picture'
        label="Image de couverture"
        value={value}
        onChange={handleChange}
    />
}